module.exports = __webpack_public_path__ + "icons/original/small/small-a3.b5693ec5ce8e44c2ab79da7d22e419c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-a3.png
// module id = x5BK
// module chunks = app